import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var GridOutlineSVG = function GridOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M12 4v8H4V4h8m1-2H3a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1zM28 4v8h-8V4h8m1-2H19a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1zM12 20v8H4v-8h8m1-2H3a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V19a1 1 0 00-1-1zM28 20v8h-8v-8h8m1-2H19a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V19a1 1 0 00-1-1z"
  }));
};
GridOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(GridOutlineSVG);